import { render, staticRenderFns } from "./AddorEdit.vue?vue&type=template&id=126664cc&scoped=true&"
import script from "./AddorEdit.vue?vue&type=script&lang=js&"
export * from "./AddorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126664cc",
  null
  
)

export default component.exports